export default "__VITE_ASSET__CmS3RFDZ__"